export default "__VITE_ASSET__4aab625f__"